import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatHrefTelPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatHrefTel'
})
export class FormatHrefTelPipe implements PipeTransform {
  /**
   * Takes a phone number and prepares it to be used as an anchor's href tel:
   */
  transform(value: string, ...args) {
    let v = String(value || '').replace(/ /g, '');
    let ext = v.match(/x\d+$/);
    let numbers = v.replace(/x\d+$/, '').replace(/\D/g, '');
    let cTen = { 0: '', 3: '-', 6: '-' };
    let cSeven = { 3: '-' };
    let i;
    let result = '';

    if (numbers.length == 11 && numbers[0] == '1') {
      numbers = numbers.slice(1);
    }

    if (numbers.length == 10) {
      result = '+1-';
      for (i = 0; i < numbers.length; i++) {
        result += (cTen[i] || '') + numbers[i];
      }
    } else if (numbers.length == 7) {
      for (i = 0; i < numbers.length; i++) {
        result += (cSeven[i] || '') + numbers[i];
      }
    } else result += numbers;

    return result; //ignoring extensions in tel
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-href-tel/format-href-tel.ts